// Imports
import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import * as classNames from 'classnames';
import { LoadingFullScreen } from 'components/indicator';

// Styles
const s = require('./FileUpload.css');

// Props
interface IFileUploadProps {
    onChange: (files: FileList) => void;
    uploading?: boolean;
    files: FileList;
    name?: string;
    title?: string;
    label?: string;
    disabled?: boolean;
    multiple?: boolean;
    acceptedExtensions?: string;
}

// Component
@observer
export class FileUpload extends React.Component<IFileUploadProps, {}> {
    static get defaultProps() {
        return {
            uploading: false,
            files: null,
            name: null,
            title: null,
            label: 'Drag file or click to upload',
            disabled: false,
            multiple: false,
            acceptedExtensions: null,
        };
    }

    constructor(props) {
        super(props);
    }

    @computed private get hasFiles(): boolean {
        return this.props.files && this.props.files.length > 0;
    }

    @computed private get label(): string {
        if (this.hasFiles) {
            let label = 'Upload: ';
            for (let i = 0; i < this.props.files.length; i++) {
                const file = this.props.files[i];
                if (i > 0) {
                    label += ', ';
                }
                label += file.name;
            }
            return label;
        } else {
            return this.props.label;
        }
    }

    public render() {
        return (
            <div
                ref={this.referenceFileUploadForm}
                className={classNames(s.fileUploadForm, {
                    [s.disabled]: this.props.disabled,
                    [s.active]: this.hasFiles,
                })}
            >

                {(this.props.title) && (
                    <h1 className={s.title}>{this.props.title}</h1>
                )}

                <div className={s.container}>
                    <div className={s.uploadGroup}>
                        {(this.label) && (
                            <p>{this.label}</p>
                        )}
                        <input
                            type="file"
                            ref={this.referenceFileField}
                            id={this.props.name || undefined}
                            name={this.props.name || undefined}
                            disabled={this.props.disabled}
                            multiple={this.props.multiple}
                            accept={this.props.acceptedExtensions || undefined}
                            draggable={true}
                            onDragLeave={this.handleDragLeave}
                            onDragEnd={this.handleDragLeave}
                            onDragEnter={this.handleDragEnter}
                            onDrop={this.handleDragDrop}
                            onClick={this.handleClick}
                            onChange={this.handleChange}
                        />
                    </div>

                    <LoadingFullScreen active={this.props.uploading} fitInContainer={true} />
                </div>

            </div>
        );
    }

    private fileField: HTMLInputElement = null;
    private referenceFileField = (ref: HTMLInputElement) => this.fileField = ref;

    private fileUploadForm: HTMLDivElement = null;
    private referenceFileUploadForm = (ref: HTMLDivElement) => this.fileUploadForm = ref;

    private handleDragEnter = (e: React.DragEvent<HTMLInputElement>): void => {
        if (this.fileField) {
            this.fileField.value = '';
        }

        if (this.fileUploadForm) {
            this.fileUploadForm.classList.add('dragging');
        }
    }

    private handleDragLeave = (e: React.DragEvent<HTMLInputElement>): void => {
        this.fileUploadForm.classList.remove('dragging');
    }

    private handleDragDrop = (e: React.DragEvent<HTMLInputElement>): void => {
        console.log('drop', e);
    }

    private handleClick = (e: React.MouseEvent<HTMLInputElement>): void => {
        if (this.fileField) {
            this.fileField.value = '';
        }
    }

    private handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.onChange(this.fileField.files);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/FileUpload.tsx